export default __webpack_public_path__ + "static/media/expense-tracker.8645dbb7.png";